import styles from "./TeamScores.module.css";

const teamScoresStyles = {
    outerContainer: `flex gap-3 items-center p-0 justify-center min-h-[57px] ${styles.outerContainer}
                     screen-500:bg-themeShadowColor screen-500:rounded-[10px] screen-500:border screen-500:border-liveGamePrimaryColor screen-500:px-[20px] screen-500:py-[7px] screen-500:gap-7
    `,
    scoreWrapper: `flex items-center gap-3 screen-500:gap-7`,
    teamDetailsContainer: `flex items-center justify-center gap-[5px]
                           screen-500:gap-[10px]
    `,
    image: `w-full h-[auto] max-w-[25px] ${styles.image}
            screen-500:max-w-[35px]
    `,
    teamScore: `text-[35px] leading-[35px] font-[600] text-white text-stroke ${styles.teamScore}`,
    versusText: `bg-liveGamePrimaryColor min-w-[30px] min-h-[1px]`,
    time_text: `text-[13px] ${styles.time_text}`,
    time_versus: `flex flex-col items-center gap-[6px]`,
    genderBanner: `hidden screen-430:flex gap-2 items-center rounded-full px-3 py-[2px] border border-red-500 bg-white screen-500:hidden`,
    genderText: `text-[10px] font-[500] text-red-500 md:text-[12px] uppercase`
}

export { teamScoresStyles }